import { Component, Input, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { LinkHelperService } from "../../../services/link-helper.service";
import { NewTabInModalDirective } from "../../../directives/new-tab-in-modal.directive";
import { RouterLink } from "@angular/router";


@Component({
    selector: "rl-entity-link",
    templateUrl: "./entity-link.component.html",
    styleUrls: ["./entity-link.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NewTabInModalDirective, RouterLink]
})
export class EntityLinkComponent implements OnInit {
	@Input()
	title: string;

	@Input()
	charTypeId: number;

	@Input()
	recordId: number;

	@Input()
	recordRevisionId: number;
	constructor(
		readonly linkHelper: LinkHelperService
	) { }

	ngOnInit(): void {
	}

}
